// Vendor libraries
import { EventEmitter, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
// Utils
import cloneDeep from 'lodash.clonedeep';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
// NgRx
import { getCurrentWizardStep, getCurrentWizardStepIndex, getPrimarySecurity, getSecondarySecurity, getSelectedReport, getTalkingPoints, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { setTalkingPoints } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/talking-points/talking-points.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Components
import { EditTalkingPointsModalDirective } from 'CustomPDFReportsApp/ts/directives/edit-talking-points-modal.directive';
import { updateSelectedReportWizardStep } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i9 from "../../../../../../../../talking_points/static/talking_points/ts/features/talking-points-edit-modal/talking-points-edit-modal.component";
import * as i10 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/edit-talking-points-modal/talking-point-item/talking-point-item.component";
function EditTalkingPointsModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.infoMessage);
} }
function EditTalkingPointsModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1, "No modules selected yet. ");
    i0.ɵɵelementEnd();
} }
function EditTalkingPointsModalComponent_ycn_talking_point_item_15_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-talking-point-item", 26);
    i0.ɵɵlistener("remove", function EditTalkingPointsModalComponent_ycn_talking_point_item_15_Template_ycn_talking_point_item_remove_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeTalkingPoint($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const talkingPoint_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("reportOrientation", ctx_r1.reportOrientation)("talkingPoint", talkingPoint_r4)("selected", true)("defaultText", ctx_r1.talkingPointsDataMap[talkingPoint_r4.talkingPoint.id].proposal_text)("securities", ctx_r1.securities)("includeBenchmark", ctx_r1.includeBenchmark);
} }
function EditTalkingPointsModalComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1, "No modules to select.");
    i0.ɵɵelementEnd();
} }
function EditTalkingPointsModalComponent_ycn_talking_point_item_26_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-talking-point-item", 27);
    i0.ɵɵlistener("add", function EditTalkingPointsModalComponent_ycn_talking_point_item_26_Template_ycn_talking_point_item_add_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addTalkingPoint($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const talkingPoint_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("talkingPoint", talkingPoint_r7)("selected", false)("defaultText", ctx_r1.talkingPointsDataMap[talkingPoint_r7.talkingPoint.id].proposal_text)("maxSelected", ctx_r1.hasMax && ctx_r1.selectedTalkingPoints.length === 2);
} }
/**
 * Edit Talking Points Modal Component
 *
 * Used for editing the Talking Points used for a module in the Custom PDF Reports in the wizard steps
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class EditTalkingPointsModalComponent extends EditTalkingPointsModalDirective {
    constructor(ngZone, featureService, store) {
        super(ngZone, featureService);
        this.ngZone = ngZone;
        this.featureService = featureService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.currentWizardStep = null;
        this.cancelButtonText = 'Back';
        this.submitButtonText = 'Next';
        this.defaultOnly = false;
        this.mapStateToComponent = (state) => {
            const selectedReport = getSelectedReport(state);
            this.reportId = selectedReport.report_id;
            this.reportDefaultOnly = selectedReport.data_source === 'default';
            this.reportOrientation = selectedReport.report_orientation;
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.securities = [getPrimarySecurity(state), getSecondarySecurity(state)];
            this.currentWizardStep = getCurrentWizardStep(state);
            if (!this.modalOpen &&
                this.currentWizardStepIndex === 0 &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_TALKING_POINTS_MODAL) {
                this.openModal();
            }
            if (this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_EDIT_TALKING_POINTS_MODAL) {
                if (this.currentWizardStep.modules === undefined) {
                    this.modules = [];
                }
                else {
                    this.modules = this.currentWizardStep.modules;
                }
            }
            this.talkingPointsModuleMap = getTalkingPoints(state);
        };
        this.moduleMapHasModuleData = (module) => {
            return (this.talkingPointsModuleMap[module.module_type] !== undefined &&
                this.talkingPointsModuleMap[module.module_type][module.step_uuid] !== undefined);
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        if (!this.isModuleMapFullyPopulated()) {
            const talkingPointsModuleMap = cloneDeep(this.talkingPointsModuleMap);
            Object.values(this.modules).forEach((module) => {
                if (!talkingPointsModuleMap[module.module_type]) {
                    talkingPointsModuleMap[module.module_type] = {};
                }
                const validPreviouslySelected = module.previously_selected.filter((talkingPointID) => Object.keys(this.talkingPointsDataMap).includes(talkingPointID.toString()));
                talkingPointsModuleMap[module.module_type][module.id] = validPreviouslySelected.map((talkingPointID) => cloneDeep(this.talkingPointsDataMap[talkingPointID]));
                talkingPointsModuleMap[module.module_type][module.step_uuid] = validPreviouslySelected.map((talkingPointID) => cloneDeep(this.talkingPointsDataMap[talkingPointID]));
            });
            this.store.dispatch(setTalkingPoints({ talkingPoints: talkingPointsModuleMap }));
        }
        if (!this.editTalkingPointsModalStepIndex) {
            this.editTalkingPointsModalStepIndex = 0;
        }
        this.modalOpen = true;
        this.initializeEditTalkingPointsModal();
    }
    isModuleMapFullyPopulated() {
        if (!this.modules || this.modules.length === 0) {
            return false;
        }
        return this.modules.every((module) => this.moduleMapHasModuleData(module));
    }
    initializeEditTalkingPointsModal() {
        const module = this.modules[this.editTalkingPointsModalStepIndex];
        this.hasMax = module.max_talking_points !== undefined;
        this.title = `Select Talking Points For ${module.module_title} Module`;
        this.description = `${this.hasMax ? 'Two' : 'Four'} Talking Points fit on ${this.hasMax ? 'half of a page.' : 'a page.'}`;
        this.includeBenchmark = module.include_benchmark;
        this.selectedTalkingPoints = this.moduleMapHasModuleData(module)
            ? this.talkingPointsModuleMap[module.module_type][module.step_uuid].map((talkingPoint) => {
                return {
                    talkingPoint: cloneDeep(talkingPoint),
                    showMore: false,
                };
            })
            : [];
        this.talkingPoints = Object.keys(this.talkingPointsDataMap)
            .filter((id) => !this.selectedTalkingPoints.find(({ talkingPoint }) => talkingPoint.id.toString() === id))
            .map((id) => {
            return {
                talkingPoint: cloneDeep(this.talkingPointsDataMap[Number.parseInt(id, 10)]),
                showMore: false,
            };
        });
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    forward() {
        const module = this.modules[this.editTalkingPointsModalStepIndex];
        const talkingPointsModuleMap = cloneDeep(this.talkingPointsModuleMap);
        if (talkingPointsModuleMap[module.module_type] === undefined) {
            talkingPointsModuleMap[module.module_type] = {};
        }
        talkingPointsModuleMap[module.module_type][module.id] = this.selectedTalkingPoints.map((_) => _.talkingPoint);
        talkingPointsModuleMap[module.module_type][module.step_uuid] = this.selectedTalkingPoints.map((_) => _.talkingPoint);
        this.store.dispatch(setTalkingPoints({ talkingPoints: talkingPointsModuleMap }));
        const updatedWizardStep = cloneDeep(this.currentWizardStep);
        if (updatedWizardStep?.modules !== undefined) {
            updatedWizardStep.modules[this.editTalkingPointsModalStepIndex].previously_selected =
                talkingPointsModuleMap[module.module_type][module.step_uuid].map((talkingPoint) => talkingPoint.id);
            // update the step in the report data in the modal
            this.store.dispatch(updateSelectedReportWizardStep({ newStep: updatedWizardStep }));
        }
        if (this.editTalkingPointsModalStepIndex + 1 < this.modules.length) {
            this.editTalkingPointsModalStepIndex += 1;
            this.initializeEditTalkingPointsModal();
        }
        else {
            this.closeModal();
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
    }
    back() {
        if (this.editTalkingPointsModalStepIndex > 0) {
            this.editTalkingPointsModalStepIndex -= 1;
            this.initializeEditTalkingPointsModal();
        }
        else {
            this.closeModal();
            if (this.currentWizardStepIndex) {
                this.store.dispatch(decrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            }
        }
    }
}
EditTalkingPointsModalComponent.ɵfac = function EditTalkingPointsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditTalkingPointsModalComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.Store)); };
EditTalkingPointsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditTalkingPointsModalComponent, selectors: [["ycn-edit-talking-points-modal"]], inputs: { defaultOnly: "defaultOnly" }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 30, vars: 21, consts: [["selectedPointsContainer", ""], ["talkingPointsEditModal", ""], [3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "bg-panel", "pt-12", "pb-12"], [1, "pr-12", "pl-12", "pb-12"], [1, "mb-row"], [3, "textContent"], ["class", "text-red", 3, "textContent", 4, "ngIf"], [1, "text-bold"], [1, "plates"], ["class", "empty-message", 4, "ngIf"], [3, "reportOrientation", "talkingPoint", "selected", "defaultText", "securities", "includeBenchmark", "remove", 4, "ngFor", "ngForOf"], [1, "pt-12", "pr-12", "pl-12", "border-t", "border-color-gray-80"], [1, "mb-row", "d-flex", "justify-content-between"], [1, "text-bold", "align-self-end"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], [1, "pb-12"], [1, "input-group", 3, "submitHandler", "searchType", "appendToBody", "defaultOnly"], [3, "talkingPoint", "selected", "defaultText", "maxSelected", "add", 4, "ngFor", "ngForOf"], [3, "cancelHandler", "submitHandler", "modalTestId", "disableSubmission", "cancelButtonText", "submitButtonText"], [3, "cancelHandler", "successHandler", "reportId", "reportOrientation", "reportDefaultOnly"], [1, "text-red", 3, "textContent"], [1, "empty-message"], [3, "remove", "reportOrientation", "talkingPoint", "selected", "defaultText", "securities", "includeBenchmark"], [3, "add", "talkingPoint", "selected", "defaultText", "maxSelected"]], template: function EditTalkingPointsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function EditTalkingPointsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function EditTalkingPointsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "div", 7)(6, "div", 8);
        i0.ɵɵelement(7, "div", 9);
        i0.ɵɵtemplate(8, EditTalkingPointsModalComponent_div_8_Template, 1, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8)(10, "div", 11);
        i0.ɵɵtext(11, "Selected Items");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 12, 0);
        i0.ɵɵtemplate(14, EditTalkingPointsModalComponent_div_14_Template, 2, 0, "div", 13)(15, EditTalkingPointsModalComponent_ycn_talking_point_item_15_Template, 1, 6, "ycn-talking-point-item", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "div", 15)(17, "div", 16)(18, "div", 17);
        i0.ɵɵtext(19, "All Talking Points");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "a", 18);
        i0.ɵɵlistener("click", function EditTalkingPointsModalComponent_Template_a_click_20_listener() { i0.ɵɵrestoreView(_r1); const talkingPointsEditModal_r5 = i0.ɵɵreference(29); ctx.modalOpen = false; return i0.ɵɵresetView(talkingPointsEditModal_r5.openModal()); });
        i0.ɵɵelement(21, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "div", 19)(23, "ycn-icon-search-autocomplete", 20);
        i0.ɵɵlistener("submitHandler", function EditTalkingPointsModalComponent_Template_ycn_icon_search_autocomplete_submitHandler_23_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addTalkingPointFromAutocomplete($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(24, "div", 12);
        i0.ɵɵtemplate(25, EditTalkingPointsModalComponent_div_25_Template, 2, 0, "div", 13)(26, EditTalkingPointsModalComponent_ycn_talking_point_item_26_Template, 1, 4, "ycn-talking-point-item", 21);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(27, "ycn-simple-modal-footer", 22);
        i0.ɵɵlistener("cancelHandler", function EditTalkingPointsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_27_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.back()); })("submitHandler", function EditTalkingPointsModalComponent_Template_ycn_simple_modal_footer_submitHandler_27_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(28, "ycn-talking-points-edit-modal", 23, 1);
        i0.ɵɵlistener("cancelHandler", function EditTalkingPointsModalComponent_Template_ycn_talking_points_edit_modal_cancelHandler_28_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.modalOpen = true); })("successHandler", function EditTalkingPointsModalComponent_Template_ycn_talking_points_edit_modal_successHandler_28_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.createTalkingPoint($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("textContent", ctx.description);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.infoMessage.length);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.selectedTalkingPoints.length === 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.selectedTalkingPoints);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", !ctx.hasEditFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", "Create New");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("searchType", "search_talking_points")("appendToBody", true)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.talkingPoints.length === 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.talkingPoints);
        i0.ɵɵadvance();
        i0.ɵɵproperty("modalTestId", "edit-talking-points-modal")("disableSubmission", ctx.selectedTalkingPoints.length === 0)("cancelButtonText", ctx.cancelButtonText)("submitButtonText", ctx.submitButtonText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("reportId", ctx.reportId)("reportOrientation", ctx.reportOrientation)("reportDefaultOnly", ctx.reportDefaultOnly);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.DisabledDirective, i5.IconSearchAutocompleteComponent, i6.ModalBaseComponent, i7.SimpleModalFooterComponent, i8.SimpleModalHeaderComponent, i9.TalkingPointsEditModalComponent, i10.TalkingPointItemComponent], encapsulation: 2 });
